const token = JSON.parse(localStorage.getItem("token"));

export const config = {
  headers: {
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
  },
};
